export default __webpack_public_path__ + "media/images/react_icons/culture-03649e07a0190f5f87bb3f167d43fd5b.svg";